import './S_Card.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps {
  className?: string;
}

export const S_Card = ({ children, className }: PropsWithChildren<IProps>): ReactElement => <div className={classNames('s-card', className)}>{children}</div>;
